import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=30c41d75&scoped=true&"
import script from "./LabelField.vue?vue&type=script&lang=js&"
export * from "./LabelField.vue?vue&type=script&lang=js&"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=30c41d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c41d75",
  null
  
)

export default component.exports